import { Reveal } from "../../common/reveal";
import { Proj10 } from "./project/personal/proj10";
import { Proj11 } from "./project/personal/proj11";
import { Proj12 } from "./project/personal/proj12";
import { Proj9 } from "./project/personal/proj9";

export const PersonalProjects = () => {
  return (
    <section className="col py-2 mb-8 mt-8 max-w-7xl mx-auto px-4">
      <div className="row p-0 m-0">
        <div className="col">
          <Reveal>
            <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">Personal Projects</h2>
          </Reveal>
        </div>
      </div>
      <Reveal>
        <div className="row p-0 m-0 grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <Proj9 />
          <Proj10 />
        </div>
        <div className="row p-0 m-0 grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <Proj11 />
          <Proj12 />
        </div>
      </Reveal>
    </section>
  );
};
